var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgCopy = function SvgCopy(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_667_7226",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_667_7226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.9974C7.04167 14.9974 6.64931 14.8342 6.32292 14.5078C5.99653 14.1814 5.83333 13.7891 5.83333 13.3307V3.33073C5.83333 2.8724 5.99653 2.48003 6.32292 2.15365C6.64931 1.82726 7.04167 1.66406 7.5 1.66406H15C15.4583 1.66406 15.8507 1.82726 16.1771 2.15365C16.5035 2.48003 16.6667 2.8724 16.6667 3.33073V13.3307C16.6667 13.7891 16.5035 14.1814 16.1771 14.5078C15.8507 14.8342 15.4583 14.9974 15 14.9974H7.5ZM4.16667 18.3307C3.70833 18.3307 3.31597 18.1675 2.98958 17.8411C2.66319 17.5148 2.5 17.1224 2.5 16.6641V4.9974H4.16667V16.6641H13.3333V18.3307H4.16667Z",
    fill: "white",
    fillOpacity: 0.5
  }))));
};
export default SvgCopy;